import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const useValidationSchema = () => {
  const { t } = useTranslation();
  return yup.object({
    verificationCode: yup
      .string()
      .matches(/^\d{6}$/, t("COMMONS.ERRORS.CODE_REGEX", { codeLength: "6" }))
      .required(t("COMMONS.ERRORS.REQUIRED")),
  });
};
